// removed by extract-text-webpack-plugin
module.exports = {"font-header":"Note-module__font-header__3lhW1","fontHeader":"Note-module__font-header__3lhW1","font-primary":"Note-module__font-primary__3QMj9","fontPrimary":"Note-module__font-primary__3QMj9","font-secondary":"Note-module__font-secondary__2OZzG","fontSecondary":"Note-module__font-secondary__2OZzG","sr-only":"Note-module__sr-only__2C48c","srOnly":"Note-module__sr-only__2C48c","sr-only-important":"Note-module__sr-only-important__2jMp1","srOnlyImportant":"Note-module__sr-only-important__2jMp1","note":"Note-module__note__1nWsb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Onboarding/Shared/Note/Note.module.scss
// module id = 660
// module chunks = 0